import { render, staticRenderFns } from "./aboutItem.vue?vue&type=template&id=78f7bd90&scoped=true&"
import script from "./aboutItem.vue?vue&type=script&lang=js&"
export * from "./aboutItem.vue?vue&type=script&lang=js&"
import style0 from "./aboutItem.vue?vue&type=style&index=0&id=78f7bd90&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f7bd90",
  null
  
)

component.options.__file = "aboutItem.vue"
export default component.exports